import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";

import useSEO from "../lib/useSEO";
import { fetchBlogPosts, imageUrl } from "../lib/api";

export default function BlogListPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogPosts()
      .then(setPosts)
      .finally(() => setLoading(false));
  }, []);

  useSEO({
    title:
      "Blog & Insight Custom Apparel — Ace Sublimasi Nusantara",
    description:
      "Tips, edukasi, dan trend seputar jersey futsal custom, jaket anime, racing apparel, dan dunia sublimasi Indonesia.",
    keywords:
      "blog jersey futsal, tips custom apparel, sublimasi vs dtf, trend jaket anime, panduan jersey custom",
    canonical: window.location.origin + "/blog",
  });

  return (
    <div data-testid="blog-list-page" className="border-b border-[#1f1f1f]">
      <section className="border-b border-[#1f1f1f] py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-bold tracking-[0.3em] uppercase text-[#CCFF00] mb-3">
            / Blog & Insight
          </p>
          <h1 className="font-display text-4xl sm:text-6xl lg:text-7xl uppercase leading-none text-white max-w-4xl">
            Cerita, Tips & <span className="text-[#CCFF00]">Insight.</span>
          </h1>
          <p className="mt-4 max-w-2xl text-base text-[#A3A3A3]">
            Bacaan singkat soal dunia custom apparel. Edukasi yang bisa kamu pakai sebelum
            nyusun pesanan tim atau brand.
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="border border-[#262626] aspect-[4/3] bg-[#0a0a0a] animate-pulse"
              />
            ))}
          </div>
        ) : (
          <div
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-6"
            data-testid="blog-list-grid"
          >
            {posts.map((p, idx) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className={`border border-[#262626] hover:border-[#CCFF00] transition-colors group flex flex-col ${
                  idx === 0 ? "md:col-span-2 md:row-span-1 lg:col-span-2" : ""
                }`}
              >
                <div
                  className={`overflow-hidden ${
                    idx === 0 ? "aspect-[16/9]" : "aspect-[4/3]"
                  }`}
                >
                  <img
                    src={imageUrl(p.cover_image)}
                    alt={p.title}
                    className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                  />
                </div>
                <div className="p-5 md:p-7 flex flex-col gap-3 flex-1">
                  <div className="flex items-center gap-3 text-xs uppercase tracking-widest text-[#A3A3A3]">
                    <span className="text-[#CCFF00] font-bold">
                      {p.tags[0]}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <Clock className="w-3 h-3" />
                      {p.read_minutes} min
                    </span>
                  </div>
                  <h2
                    className={`font-display uppercase text-white leading-tight tracking-tight ${
                      idx === 0 ? "text-3xl md:text-4xl" : "text-xl md:text-2xl"
                    }`}
                  >
                    {p.title}
                  </h2>
                  <p className="text-sm text-[#A3A3A3] line-clamp-3">
                    {p.excerpt}
                  </p>
                  <span className="mt-auto pt-4 inline-flex items-center gap-2 text-[#CCFF00] text-xs font-bold uppercase tracking-widest">
                    Baca artikel <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
